import { render, staticRenderFns } from "./colorForm.vue?vue&type=template&id=1f8577c1&"
import script from "./colorForm.vue?vue&type=script&lang=js&"
export * from "./colorForm.vue?vue&type=script&lang=js&"
import style0 from "./colorForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports